import { render, staticRenderFns } from "./lottery-set.vue?vue&type=template&id=688c63fe&scoped=true&"
import script from "./lottery-set.vue?vue&type=script&lang=js&"
export * from "./lottery-set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688c63fe",
  null
  
)

export default component.exports